import { render, staticRenderFns } from "./FlightItinerarySummary.vue?vue&type=template&id=4a85eecf&scoped=true&"
import script from "./FlightItinerarySummary.vue?vue&type=script&lang=js&"
export * from "./FlightItinerarySummary.vue?vue&type=script&lang=js&"
import style0 from "./FlightItinerarySummary.vue?vue&type=style&index=0&id=4a85eecf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a85eecf",
  null
  
)

/* custom blocks */
import block0 from "./FlightItinerarySummary.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VIcon,VRow,VSpacer,VTooltip})
